import { Button, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { format, isFuture, isToday, Locale } from 'date-fns'
import { FC, useState } from 'react'
import PlusIcon from '../../../../assets/icons/Plus.svg'
import { CalendarData } from '../../../../types/calendar'
import { CreateEventMenu } from './CreateEventMenu'
import { EventItem } from './EventItem'

type Props = {
    selectedDate: Date
    locale?: Locale
    data: CalendarData
}

export const EventsSidebar: FC<Props> = ({ selectedDate, locale, data }) => {
    const { breakpoints } = useTheme()

    const isMobile = useMediaQuery(breakpoints.down('md'))

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()

        setAnchorEl(event.currentTarget)
    }
    const handleCloseMenu = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)

    const displayCreateButton = isFuture(selectedDate) || isToday(selectedDate)

    const events = data[selectedDate.toISOString()] ?? []
    const hasEvents = !!events.length

    return (
        <Stack
            sx={{
                height: '100%',
                width: isMobile ? '100%' : '240px',
                minWidth: isMobile ? '100%' : '240px',
                borderLeft: '1px solid #F2F2F2',
                p: 0,
                borderTop: isMobile ? '1px solid #F2F2F2' : 'none',
                overflowY: isMobile ? 'auto' : 'hidden',
            }}>
            <CreateEventMenu
                selectedDate={selectedDate}
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            />
            <Stack
                direction="row"
                sx={{
                    p: isMobile ? '14px 12px 8px 12px' : 2,
                    pb: isMobile ? undefined : 1,
                }}>
                <Typography variant={isMobile ? 'body2' : 'Subtitle1'} color="#333333">
                    {format(selectedDate, 'd MMMM yyyy', { locale })}
                </Typography>
            </Stack>
            <Stack
                direction="column"
                sx={{
                    height: '100%',
                    padding: isMobile ? '0 12px 8px 12px' : '0 16px 16px 16px',
                    overflowY: isMobile ? 'visible' : 'auto',
                    alignItems: isMobile && !hasEvents ? 'center' : 'start',
                    justifyContent: isMobile && !hasEvents ? 'center' : 'start',
                }}>
                {!hasEvents ? (
                    <Typography
                        variant="Description"
                        sx={{
                            padding: '8px 0',
                            color: '#5A5C5E',
                        }}>
                        Ещё нет событий
                    </Typography>
                ) : (
                    <>
                        {events.map((data, index) => (
                            <EventItem
                                key={`day_event_${index}`}
                                variant="column"
                                popoverPosition="left"
                                data={data}
                            />
                        ))}
                    </>
                )}
            </Stack>
            {displayCreateButton && (
                <>
                    {isMobile ? (
                        <>
                            {!hasEvents ? (
                                <Stack
                                    direction="row"
                                    sx={{
                                        p: '12px',
                                    }}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        startIcon={<PlusIcon />}
                                        onClick={handleOpenMenu}
                                        sx={{
                                            minHeight: '40px',
                                            height: '40px',
                                            '.MuiButton-startIcon': {
                                                marginRight: 0,
                                            },
                                        }}>
                                        Создать событие
                                    </Button>
                                </Stack>
                            ) : (
                                <IconButton
                                    onClick={handleOpenMenu}
                                    sx={{
                                        width: '40px',
                                        height: '40px',
                                        position: 'absolute',
                                        bottom: '32px',
                                        right: '32px',
                                        backgroundColor: '#006CFD',
                                        color: '#FFFFFF',

                                        ':hover': {
                                            backgroundColor: '#004B9F',
                                        },
                                    }}>
                                    <PlusIcon />
                                </IconButton>
                            )}
                        </>
                    ) : (
                        <Stack
                            direction="row"
                            sx={{
                                p: 2,
                            }}>
                            <Button
                                variant="contained"
                                fullWidth
                                startIcon={<PlusIcon />}
                                onClick={handleOpenMenu}
                                sx={{
                                    minHeight: '32px',
                                    height: '32px',
                                    '.MuiButton-startIcon': {
                                        marginRight: 0,
                                    },
                                }}>
                                Создать событие
                            </Button>
                        </Stack>
                    )}
                </>
            )}
        </Stack>
    )
}
